import React from 'react';
import { Navigate, Routes, Route, Outlet, HashRouter} from 'react-router-dom';
import Signin from "../layouts/Auth/signin/Signin";
import Signup from "../layouts/Auth/signup/Signup";
import Viewer from '../layouts/Viewer/Viewer';
import List from "../layouts/Panel/list/List";
import Panel from "../layouts/Panel/Panel";
import Auth from "../layouts/Auth/Auth";
import Storage from "../helpers/Storage";
import PrintReport from "../layouts/Print/PrintReport.jsx";
import NotFound from "../layouts/404/NotFound";
import Api from "../core/api/Api";
import snippets from "../helpers/snippets";
import BrowserNotSupported from "../layouts/BrowserNotSupported/BrowserNotSupported";
import Help from "../layouts/Help/Help";
import packageJson from "../../package.json";
import StructuralReport from "../layouts/Reports/structural-report/StructuralReport";
// import AudioRecognition from "../shared/component/AudioRecognition/AudioRecognition";
import ReportOrViewer from "../layouts/Reports/report/ReportOrViewer";
// import Teset from "./Teset";

const api = new Api()

const ProtectedRoute = ({user, redirectPath = `/signin?returnUrl=${encodeURIComponent(window.location.hash.substring(2))}`}) => {
    let now = Date.parse(new Date())
    let tokenTime = Storage.getTicketTime();
    let refreshToken = Storage.getRefreshTicket()
    if (!Storage.getUserInfo()?.token || snippets.isObjectEmpty(refreshToken)) {
        // redirect to signin for new systems that we do not saved refresh token for them
        return <Navigate to={redirectPath} replace/>;
    }
    if (packageJson.version !== Storage.uiVersionGet()) {
        Storage.removeStorageData();
        return <Navigate to={redirectPath} replace/>;
    }
    if ((now - tokenTime) > 1000*60*60*3) {
        if (Storage.getRememberMe() === true){
            refreshExpiredToken(refreshToken);
        } else {
            Storage.removeStorageData();
            return <Navigate to={redirectPath} replace/>;
        }
    }
    return <Outlet/>;
};
 const refreshExpiredToken = async (rTicket) => {
     api.setPoint(`1/login?refresh_token=${rTicket}`)
     await api.send('get').then((response) => {
         Storage.setEditLogin(response)
         window.location.reload()
     }).catch((error) => {
         //TODO: make a better redirection to sign in page
         console.log(error)
         Storage.removeStorageData();
         window.location.href = '#/signin';
     })
}

const MyRout = () => {
    let supportedBrowsers = snippets.checkBrowser()
    const user = {
        allow: false,
        redirectPath: '/signin'
    };
    return (
        <HashRouter>
            {supportedBrowsers ?
            <Routes>
                <Route element={<Auth/>}>
                    <Route path="/signin" index element={<Signin/>}/>
                    <Route path="/signup" element={<Signup/>}/>
                </Route>

                <Route element={<ProtectedRoute user={user}/>}>
                    <Route path="/view/:studyID/:reportID/:mode" element={<Viewer />}/>
                    <Route path="/report/:studyID/:reportID/" element={<ReportOrViewer parentComp={"report"}/>}/>
                    <Route path="/structural_report/:studyID/:reportID/" element={<StructuralReport />}/>
                    <Route path="/print/:studyID/:reportID" element={<PrintReport />}/>
                    {/*<Route path="/audio" element={<AudioRecognition />}/>*/}
                    <Route path="/help/:manual" element={<Help />}/>
                    {/*<Route path="/test" element={<Teset />}/>*/}
                    <Route element={<Panel/>}>
                        <Route exact path="/list" element={<List/>}/>
                        <Route path="/" element={<List/>}/>
                    </Route>
                </Route>
                <Route path={"*"} element={<NotFound/>}/>
            </Routes>
            :
            <Routes>
                <Route path={"*"} element={<BrowserNotSupported/>}/>
            </Routes>}
        </HashRouter>
    );
};

export default MyRout;
